/** The top line of a role block: its name, the rate in force, and Set rate. */
import type { Ref } from 'react';

import type { CurrentRate } from '../../../api/staff-pay-rates';

import CurrentRateSummary from './CurrentRateSummary';

export default function PayRateRoleHeader({
  label,
  current,
  showSetRate,
  onSetRate,
  headingRef,
  setRateRef,
}: {
  label: string;
  current: CurrentRate;
  showSetRate: boolean;
  onSetRate: () => void;
  headingRef: Ref<HTMLHeadingElement>;
  setRateRef: Ref<HTMLButtonElement>;
}) {
  return (
    <div className="flex items-center justify-between gap-3">
      <div className="flex items-baseline gap-3">
        <h3
          ref={headingRef}
          tabIndex={-1}
          className="w-20 text-xs font-semibold uppercase text-stone-600 dark:text-stone-400 outline-none"
        >
          {label}
        </h3>
        <CurrentRateSummary current={current} />
      </div>
      {showSetRate && (
        <button
          ref={setRateRef}
          type="button"
          onClick={onSetRate}
          className="min-h-[24px] rounded px-2 text-xs text-moss-700 dark:text-moss-400 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-moss-500"
        >
          Set rate
        </button>
      )}
    </div>
  );
}
